import * as XLSX from "xlsx";

export const convertCsvToArray = (csvBlob: Blob): Promise<string[][]> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (event) => {
            try {
                const csvData = event.target?.result as string;

                // Dividir el contenido del CSV en filas
                const rows = csvData.split("\n");

                // Dividir cada fila en columnas
                const data = rows.map((row) => {
                    // Usar una expresión regular para manejar valores entre comillas
                    return row
                        .trim()
                        .split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/) // Manejar comas dentro de valores entre comillas
                        .map((cell) => cell.replace(/^"|"$/g, "")); // Eliminar comillas alrededor de los valores
                });

                resolve(data);
            } catch (error) {
                reject(error);
            }
        };

        reader.onerror = () => reject(reader.error);
        reader.readAsText(csvBlob);
    });
};


export const convertArrayInExcel = (data: string[][], fileName: string): void => {
    // Crear una hoja de Excel a partir de los datos
    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, fileName);

    // Generar el archivo Excel
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

    // Crear un enlace para descargar el archivo
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName + ".xlsx"; // Nombre del archivo
    a.click();
    URL.revokeObjectURL(url); // Liberar el objeto URL
};

const CsvUtils = {
    convertCsvToArray,
    convertArrayInExcel,
};

export default CsvUtils;